export default class MathUtils {
  static calcularMediaSimples(pValorTotal: number, pQuantidade: number): number {
    try {
      if (!pValorTotal || !pQuantidade) return 0;

      return pValorTotal / pQuantidade;
    } catch (error) {
      throw error;
    }
  }

  static formatarMilesegundos(pTempoMilisegundos: number, pFormato: 'hh:mm:ss' | '0h 0m 0s') {
    if (pFormato == 'hh:mm:ss') {
      if (!pTempoMilisegundos) return '00:00:00';
      const totalSegundos = Math.floor(pTempoMilisegundos / 1000);
      const horas = Math.floor(totalSegundos / 3600);
      const minutos = Math.floor((totalSegundos % 3600) / 60);
      const segundos = totalSegundos % 60;

      return [horas, minutos, segundos].map((val) => val.toString().padStart(2, '0')).join(':');
    } else if (pFormato == '0h 0m 0s') {
      const totalSegundos = Math.floor(pTempoMilisegundos / 1000);
      const horas = Math.floor(totalSegundos / 3600);
      const minutos = Math.floor((totalSegundos % 3600) / 60);
      const segundos = totalSegundos % 60;
      const partes: string[] = [];
      if (horas > 0) partes.push(`${horas}h`);
      if (minutos > 0) partes.push(`${minutos}min`);
      if (segundos > 0 || partes.length === 0) partes.push(`${segundos}s`);
      return partes.join(' ');
    } else {
      throw `O formato informado: "${pFormato}" é inválido ou não foi mapeado na classe ${this.constructor.name}`;
    }
  }

  static toBooleano(pValor: any): boolean {
    //  Proteção contra null/undefined imediata
    if (pValor === null || pValor === undefined) {
      return false;
    }

    // Se já for booleano, retorna direto
    if (typeof pValor === 'boolean') {
      return pValor;
    }

    //  Converte para string, remove espaços e põe em minúsculo
    const valorNormalizado = String(pValor).trim().toLowerCase();

    if (valorNormalizado === 'true' || valorNormalizado === '1' || valorNormalizado === 'on') {
      return true;
    }

    if (valorNormalizado === 'false' || valorNormalizado === '0') return false;

    return false;
  }
}
